import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const ServerErrorPage = () => {
  return (
    <div className="relative min-h-screen flex flex-col">
      <Helmet>
        <title>500 - Sunucu Hatası</title>
        <meta
          name="description"
          content="Üzgünüz, bir sunucu hatası oluştu. Lütfen sayfayı yenileyin veya ana sayfaya dönün."
        />
      </Helmet>
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-center flex-1 p-4 relative z-10">
        {/* Sol Panel: Görsel500 */}
        <div className="flex w-full sm:w-1/2 mt-4 justify-center">
          <img
            src="/illustrations500.svg"
            alt="500 Hata Sayfası"
            className="w-full h-auto max-w-[300px] sm:max-w-[400px] md:max-w-[500px]"
          />
        </div>
        {/* Sağ Panel: Metin ve Butonlar */}
        <div className="flex w-full sm:w-1/2">
          <div className="flex flex-col gap-4 sm:gap-8">
            {/* Metinler */}
            <div className="flex flex-col  text-left  gap-4 sm:gap-8">
              <img
                src="/500.svg" // Görsel dosyanı buraya ekle
                alt="500 Illustration"
                className="w-[200px] h-[80px] md:w-[310px] md:h-[120px] sm:w-[250px] sm:h-[100px]"
              />
              <div className="flex flex-col gap-2 items-start">
                <p className="text-lg font-semibold text-grayy">Üzgünüz :(</p>
                <p className="text-base text-grayy">
                  Bu sayfa görüntülenemiyor.
                </p>
              </div>
            </div>
            {/* Butonlar */}
            <div className="flex gap-4">
              <Link to="/" className="btn-dark text-white text-xs">
                Ana sayfaya Dön
              </Link>
              <button
                onClick={() => window.location.reload()}
                className="btn-white text-dark text-xs"
              >
                Sayfayı Yenile
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerErrorPage;
